import GrievanceView from "../../../jsx/components/Dashboard/GrievanceView/grievanceview";

const GrievanceViewWrapper = () => {
  return <GrievanceView />;
};

export const allowedRoles = [_enum.ROUTE_PERSONAS.admin];
export default constore(GrievanceViewWrapper);
